import api from './api';
import {
  Visit,
  VisitFilters,
  VisitStats,
  ScheduleVisitData,
} from '@/types/visit.types';
import { PaginatedResponse, VisitResponse } from '@/types';

export const visitsService = {
  // Get all visits with filters and pagination
  getAll: (filters?: VisitFilters, page = 1, limit = 20) =>
    api.get<PaginatedResponse<Visit>>('/visits', {
      params: { ...filters, page, limit },
    }),

  // Get single visit by ID - returns { visit: {...} }
  getById: (id: string) =>
    api.get<VisitResponse>(`/visits/${id}`),

  // Get today's visits - returns { visits: [...] }
  getToday: () =>
    api.get<{ visits: Visit[] }>('/visits/today'),

  // Get upcoming visits - returns { visits: [...] }
  getUpcoming: (days = 7) =>
    api.get<{ visits: Visit[] }>('/visits/upcoming', { params: { days } }),

  // Get visit statistics
  getStats: () =>
    api.get<VisitStats>('/visits/stats'),

  // Schedule a new visit - API returns { visit: {...} }
  schedule: (data: ScheduleVisitData) =>
    api.post<{ visit: Visit }>('/visits', data),

  // Reschedule an existing visit
  reschedule: (id: string, date: string, time?: string) =>
    api.post<Visit>(`/visits/${id}/reschedule`, {
      scheduled_date: date,
      scheduled_time: time,
    }),

  // Cancel a visit
  cancel: (id: string, reason?: string) =>
    api.post<Visit>(`/visits/${id}/cancel`, { reason }),

  // Mark visit as no show
  markNoShow: (id: string) =>
    api.post<Visit>(`/visits/${id}/no-show`),

  // Complete a visit with token verification
  complete: (id: string, token: string) =>
    api.post<Visit>(`/visits/${id}/complete`, { token }),
};

export default visitsService;
